import { render, staticRenderFns } from "./PedidosPagamento.vue?vue&type=template&id=03e4a74c"
import script from "./PedidosPagamento.vue?vue&type=script&lang=js"
export * from "./PedidosPagamento.vue?vue&type=script&lang=js"
import style0 from "./PedidosPagamento.vue?vue&type=style&index=0&id=03e4a74c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports